import { Box, Button, Grid, IconButton } from "@mui/material";
import CustomInput from "../components/ui/CustomInput";
import PageHeader from "../components/ui/PageHeader";
import PageForm from "../components/ui/PageForm";
import BarcodeIcon from "../components/ui/BarcodeIcon";
import CustomGridCell from "../components/ui/CustomGridCell";
import CustomGridHeaderCell from "../components/ui/CustomGridHeaderCell";
import { useRef, useState, useEffect } from "react";
import CustomTable from "../components/ui/CustomTable";
import axios from "../api/axiosClient";
import CustomTablePagingInfo from "../components/ui/CustomTablePagingInfo";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from 'dayjs';
import {
  handleError,
  errorToast,
  useKeyDown,
  addDownloadLinkToDocument,
} from "../services/serviceBase";
import toast from "react-hot-toast";
import DownloadIcon from "@mui/icons-material/Download";

const SapMasterData = () => {
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);

  const { setLoading } = useLoading();

  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());

  const [shouldFilterCollapse, setShouldFilterCollapse] = useState(false);

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);

  const [tableHeigth, setTableHeigth] = useState(260);

  const handleDatesValidation = () => {
    if (fromDate != null && toDate != null && fromDate > toDate) {
      setFromDate(null);
      setToDate(null);
      toast.error(
        intl.formatMessage({ id: "Error.StartDateLaterThenEndDate" })
      );
    } else if (fromDate != null) {
      setFromDate(fromDate);
    } else if (toDate != null) {
      setToDate(toDate);
    }
  };

  useEffect(() => {
    handleDatesValidation();
  }, [fromDate, toDate]);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 10;

  useKeyDown(() => {
    handleSearch();
  }, ["Enter"]);

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var headerHeight = document.querySelector("#header").clientHeight;
    var pagingInfoHeight = document.querySelector("#pagingInfo").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight =
      pageHeight - fromHeight - headerHeight - pagingInfoHeight - 90;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useEffect(() => {
    getColumns();
  }, [rows, page, tableHeigth]);

  const handleDownload = async (idSAPMasterDataFile) => {
    try {
      const response = await axios.post(`/sapdata/${idSAPMasterDataFile}/txt`, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "download.txt"; // TODO: usa nome file vero

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/)?.[1];
        if (fileNameMatch) {
          fileName = fileNameMatch;
        }
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Errore durante il download:", error);
    }
  };

  const getColumns = () => {
    setColumns([
      {
        field: "fileName",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "SAPMD.FileName" })}
          />
        ),
        flex: 1,
        minWidth: 250,
      },
      {
        field: "creationDate",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "SAPMD.FileDate" })}
          />
        ),
        renderCell: (params) => {
          return moment(params.row.creationDate).format("DD/MM/YYYY");
        },
        flex: 1,
        minWidth: 90,
      },
      {
        field: "actions2",
        type: "actions2",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Download" })}
          />
        ),
        minWidth: 90,
        resizable: false,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(e) => handleDownload(params.row.idSAPMasterDataFile)}
            >
              <DownloadIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  const handleSearchClick = () => {
    page.current = 0;
    handleSearch();
  };

  const handleSearch = () => {
    setShouldFilterCollapse(false);
    setLoading(true);
    const params = new URLSearchParams([]);

    if (fromDate !== undefined && fromDate !== "" && fromDate !== null) {
      var date = fromDate.toISOString().substring(0, 10);
      params.append("StartDate", date);
    }

    if (toDate !== undefined && toDate !== "" && toDate !== null) {
      var date = toDate.toISOString().substring(0, 10);
      params.append("EndDate", date);
    }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);
    axios
      .get("/sapdata", { params })
      .then((response) => {
        setShouldFilterCollapse(true);
        setLoading(false);
        resizeTable();

        var data = [];
        response.data.paginatedItems.map((x) => {
          var item = x;
          item.sapMDDataId = x.idSAPMasterDataFile + "-" + x.filePath;
          data.push(item);
        });

        setRows(data);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  };

  const handleReset = () => {
    setFromDate(null);
    setToDate(null);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearch();
    }
  };

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const handleDownloadExcel = async () => {
      setLoading(true);
      axios
        .get("/sapdata/excel")
        .then((response) => {
          setLoading(false);
          window.open(response.data, "_blank");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader title={intl.formatMessage({ id: "SAPMD.Title" })} />
      <PageForm
        adjustHeightFunc={handletrasitionEnd}
        shouldCollapse={shouldFilterCollapse}
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item lg={12} pt={0}>
                <Grid item lg={3} pt={0}>
                  <Button
                  variant="contained"
                  sx={{ width: "100%", marginBottom: "10px" }}
                  className="apeLigthBlueBackground"
                  onClick={handleDownloadExcel}
                >
                  {intl.formatMessage({ id: "SAPMD.CurrentData" })}
                </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item md={5}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.FromDate",
                      })}
                      type="date"
                      valueRef={fromDate}
                      setValue={setFromDate}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={2}></Grid>
                  <Grid item md={5}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.ToDate",
                      })}
                      type="date"
                      valueRef={toDate}
                      setValue={setToDate}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={2} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleReset}
                >
                  {intl.formatMessage({ id: "General.Reset" })}
                </Button>
              </Grid>
              <Grid item md={8}></Grid>
              <Grid item md={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearchClick}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <CustomTablePagingInfo
        totalCount={totalCount}
        page={page.current}
        maxPage={maxPage.current}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
      />
      <CustomTable
        columns={columns}
        rows={rows}
        id={"sapMDDataId"}
        rowHeight={70}
        headerHeight={80}
        tableHeight={tableHeigth}
      />
    </Box>
  );
};

export default SapMasterData;
